<template>
  <v-container
    fluid
    class="pt-2 grey lighten-2"
    :class="{ 'px-2': $vuetify.breakpoint.width <= 1600, 'pl-0': $vuetify.breakpoint.width > 1600 }"
  >
    <v-layout>
      <v-flex xs6 sm3 class="user-details-container">
        <v-card class="pa-2">
          <v-list three-line dense class="transparent">
            <template v-for="user in users">
              <v-list-item :key="user.id" @click="selectUser(user)" :class="{ selected: isActiveUser(user.id) }">
                <v-list-item-content>
                  <v-list-item-title>{{ user.full_name }}</v-list-item-title>
                  <v-list-item-subtitle class="text--primary">{{ user.email }}</v-list-item-subtitle>
                  <v-list-item-subtitle
                    ><strong>Last login: </strong> {{ lastLoggedInDate(user.last_logged_in_at) }}</v-list-item-subtitle
                  >
                </v-list-item-content>
                <v-list-item-action>
                  <v-icon v-if="user.recipient" color="accent">notifications_active</v-icon>
                  <v-icon v-else>notifications_off</v-icon>
                </v-list-item-action>
              </v-list-item>
              <v-divider :key="`divider-${user.id}`"></v-divider>
            </template>
            <v-list-item>
              <v-list-item-content>
                <v-btn @click="showNewUser = true">Add new user</v-btn>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-flex>
      <v-flex xs12 sm6>
        <v-card class="ml-2">
          <v-toolbar flat color="white" class="pl-3">
            <v-toolbar-title>{{ selectedUser.full_name }}</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-container grid-list-md>
              <v-form>
                <v-layout wrap>
                  <v-flex xs12 sm6>
                    <v-text-field v-model="updateUser.first_name" label="First name"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field v-model="updateUser.last_name" label="Last name"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field v-model="updateUser.email" label="Email"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field v-model="updateUser.phone" label="Phone"></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex>
                    <v-switch v-model="updateUser.recipient" label="Receive notifications"></v-switch>
                  </v-flex>
                  <v-flex v-for="role in updateUser.roles" :key="role">
                    <v-switch
                      v-if="role === 'Provider'"
                      v-model="updateUser.funder_newsletter_signup"
                      label="Receive Funder Newsletter"
                    ></v-switch>
                    <v-switch
                      v-if="role === 'Partner'"
                      v-model="updateUser.partner_newsletter_signup"
                      label="Receive Partner Newsletter"
                    ></v-switch>
                  </v-flex>
                </v-layout>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-divider></v-divider>
                  </v-flex>
                  <v-flex xs12 sm6 v-if="!UserHasRole('Platform')">
                    <v-text-field
                      hint="At least 8 characters"
                      min="8"
                      :append-icon="p1 ? 'visibility' : 'visibility_off'"
                      @click:append="() => (p1 = !p1)"
                      :type="p1 ? 'password' : 'text'"
                      counter
                      v-model="updateUser.password"
                      label="Reset password"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 v-if="!UserHasRole('Platform')">
                    <v-text-field
                      hint="At least 8 characters"
                      min="8"
                      :append-icon="p2 ? 'visibility' : 'visibility_off'"
                      @click:append="() => (p2 = !p2)"
                      :type="p2 ? 'password' : 'text'"
                      counter
                      v-model="updateUser.password_confirm"
                      :error-messages="passwordErrorMessage"
                      label="Confirm password"
                    >
                    </v-text-field>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-btn color="accent" @click="sendWelcomeMessage" text>Send Welcome Email</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="accent" @click="updateSelectedUser()">Update</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <new-user-dialog
      :show.sync="showNewUser"
      :selectedBusinessId="SelectedFunder.provider.id"
      :selectedBusinessName="SelectedFunder.provider.name"
      @success="refreshFunder"
    ></new-user-dialog>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import _ from 'lodash';
import moment from 'moment';
import NewUserDialog from '../NewUserDialog';

export default {
  components: { NewUserDialog },
  name: 'funder-users',
  data: () => ({
    showNewUser: false,
    users: [],
    selectedUser: {},
    updateUser: {},
    p1: true,
    p2: true,
    valid: true
  }),
  computed: {
    ...mapGetters(['SelectedFunder', 'SelectedFunderUser', 'UserHasRole', 'UserEmail']),
    passwordErrorMessage() {
      return this.updateUser.password === this.updateUser.password_confirm
        ? []
        : ["The passwords you entered don't match"];
    }
  },
  methods: {
    ...mapActions([
      'selectFunderUser',
      'updateFunderUser',
      'sendFunderWelcomeMessage',
      'addNotification',
      'selectFunder'
    ]),
    selectUser: function(user) {
      this.selectedUser = user;
      this.updateUser = _.clone(user);
    },
    updateSelectedUser() {
      const updates = this.diff(this.updateUser, this.selectedUser);
      if (updates.password !== null && updates.password !== updates.password_confirm) {
        this.addNotification({
          text: `Your passwords must match`,
          colour: 'red'
        });
        return;
      }
      updates.isRecipient = this.updateUser.recipient;
      updates.product_id = this.SelectedFunder.id;
      this.updateFunderUser({ id: this.selectedUser.id, updates });
    },
    sendWelcomeMessage() {
      this.sendFunderWelcomeMessage(this.selectedUser.id);
    },
    isActiveUser(id) {
      return id === this.selectedUser.id;
    },
    isDefined(value) {
      return !_.isUndefined(value);
    },
    isRecipient(id) {
      const record = _.find(this.SelectedFunder.recipients, { id });
      return this.isDefined(record);
    },
    resetSelectedUser() {
      this.selectedUser = {};
    },
    diff(object, base) {
      function changes(object, base) {
        return _.transform(object, (result, value, key) => {
          if (!_.isEqual(value, base[key])) {
            result[key] = _.isObject(value) && _.isObject(base[key]) ? changes(value, base[key]) : value;
          }
        });
      }
      return changes(object, base);
    },
    refreshFunder() {
      this.addNotification({
        text: `User added`
      });
      this.selectFunder({ id: this.SelectedFunder.id });
    },
    lastLoggedInDate(date) {
      return _.isNull(date) ? 'never' : moment(date).format('DD/MM/YYYY hh:mm:ss');
    }
  },
  mounted() {},
  watch: {
    SelectedFunderUser: {
      immediate: true,
      handler() {
        this.resetSelectedUser();
        this.users = this.UserHasRole('Platform')
          ? this.SelectedFunder.provider.users
          : _.filter(this.SelectedFunder.provider.users, user => user.email === this.UserEmail);

        this.selectedUser = this.users[0];
        this.updateUser = _.clone(this.users[0]);
      }
    },
    SelectedFunder: {
      immediate: true,
      handler() {
        this.users = this.UserHasRole('Platform')
          ? this.SelectedFunder.provider.users
          : _.filter(this.SelectedFunder.provider.users, user => user.email === this.UserEmail);
      }
    },
    deep: true
  }
};
</script>

<style lang="scss" scoped>
.user-details-container {
  height: calc(100vh - 130px);
  max-height: calc(100vh - 130px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.selected {
  background: rgba(0, 0, 0, 0.08);
  .list__tile__title {
    font-weight: 600;
  }
}
</style>
